import React from 'react';
import _ from 'lodash';
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';
import { useDebouncedCallback } from 'use-debounce';

import { InfoField } from './InfoField';
import { handleShowOn, handleDynamicFunction, constructDependsOnParams } from '../../services/functions';
import { useDynamicFunction, useDynamicAction, useDynamicQuery, useDidMountEffect } from '../../services/hooks/';

export const BoolField = props => {
  const { field, formik, getFieldCallback, updateOptionsCallback,
    setLoadingCallback, metaData, hideFieldCallback, formIdentifier } = props;
  const action = useDynamicAction(
    field.depends_on,
    field.on_change_splitted ? field.on_change_splitted[1] : field.on_change,
    constructDependsOnParams(field.depends_on, field.name, formik.values
    ),
    formik.values[field.name]
  );
  const { query, data, loading } = useDynamicQuery(action);
  const dynamicFunction = useDynamicFunction(field.on_change_splitted ? field.on_change_splitted[0] : field.on_change);
  const secondDynamicFunction = useDynamicFunction(field.on_change_splitted ? field.on_change_splitted.length > 1 ? field.on_change_splitted[2] : null : null);
  const fontStyle = ['quick_payment_promotion', 'child_english_communicative'].includes(field.name) ? { fontWeight: 700, fontSize: '1rem' } : {};
  const controlStyle = field.name == 'quick_payment_promotion' ? { marginBottom: 12, marginTop: 3 } : {};
  React.useEffect(() => {
    updateOptionsCallback(data);
  }, [data]);

  React.useEffect(() => {
    setLoadingCallback(loading);
  }, [loading]);

  const debounced = useDebouncedCallback(
    val => {
      if (!_.isNil(dynamicFunction)) {
        if (dynamicFunction.functionName === 'setEmptyChoicesFunction') {
          const newObjects = {};
          _.forEach(dynamicFunction.data, item => {
            newObjects[item] = '';
          });
          newObjects[field.name] = val;
          formik.setValues({ ...formik.values, ...newObjects });
        } else {
          const res = handleDynamicFunction(dynamicFunction, formik, field, val);
          if (res.callback) {
            props[res.callback](res.data, field.options.indexOf(val));
          }
        }
      } else {
        formik.setFieldValue(field.name, val);
      }
      if (!_.isNil(secondDynamicFunction)) {
        // Druga dynamiczna opcja na ten moment obsługuje setRequiredFieldsFunction. Na przykładzie boskich wakacji:
        // "onChange": "setEmptyChoicesFunction(resort, event, camp, accomodation);getDependsOnSeasonsAction;setRequiredFieldsFunction(boskie_wakacje-true)",
        const res = handleDynamicFunction(secondDynamicFunction, formik, field, val);
        if (res.callback) {
          props[res.callback](res.data, field.options.indexOf(val));
        }
      }
      if (field.name == 'no_pesel') {
        formik.setFieldValue('participant_gender', '');
      }
    },
    300
  );

  useDidMountEffect(() => {
    if (!_.isNil(action)) {
      query();
    }
  }, [formik.values[field.name]]);

  useDidMountEffect(() => {
    if (formIdentifier == 'lato' && field.name == 'quick_payment_promotion' && formik.values.camp && formik.values.quick_payment_promotion_obj) {
      // Promocja szybkiej płatności dostępna jest tylko na 35+ dni przed rozpoczęciem turnusu
      const metaDataCamp = metaData.camps.find(o => o.id == formik.values.camp);
      if (!metaDataCamp) {
        return;
      }
      const today = new Date();
      // różnica w milisekundach
      const diffTime = new Date(metaDataCamp.date_from).getTime() - today.getTime();
      // różnica w dniach (zaokrąglona w dół)
      const daysDiff = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      if (daysDiff < 35) {
        hideFieldCallback('quick_payment_promotion', false, false);
        formik.setFieldValue('quick_payment_promotion', false);
      } else {
        hideFieldCallback('quick_payment_promotion', true, false);
      }
    } else if (formIdentifier == 'wyjazdy_rodzinne' && field.name == 'quick_payment_promotion' && formik.values.period && formik.values.quick_payment_promotion_obj) {
      // Promocja szybkiej płatności dostępna jest zawsze
      hideFieldCallback('quick_payment_promotion', true, false);
    }
  }, [formik.values.camp, formik.values.period, formik.values.quick_payment_promotion_obj]);

  return (
    <FormControl style={{ ...controlStyle, display: field.hide ? 'none' : handleShowOn(
      field.show_on, formik.values,
      getFieldCallback(!_.isNil(field.show_on) ? field.show_on.trim().split(' ')[0].split('-')[0] : []), field.show_on_condition ? field.show_on_condition : 'OR')
      ? ''
      : 'none' }} fullWidth>
      <FormControlLabel
        control={
          <Checkbox
            name={field.name}
            checked={formik.values[field.name] || false}
            onChange={e => debounced(!formik.values[field.name])}
          />
        }
        label={<span style={fontStyle} dangerouslySetInnerHTML={{ __html: field.label }}></span>}
      />
      <FormHelperText sx={{ color: '#FF4842' }}>{formik.touched[field.name] && formik.errors[field.name]}</FormHelperText>
      {
        !_.isEmpty(field.infos)
          ? _.map(field.infos, (info, key) => <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} />)
          : null
      }
    </FormControl>
  );
};
